<div class = "status">
    <mat-icon class = "status-icon" [svgIcon]=currStatusIcon></mat-icon>  
    <span class = "status-text" [ngClass]="setProvisionStatus()"> 
        {{stepNameText}}<span>{{stepStatusText}}</span>.
    </span>
</div>
<div class = "bar">
    <div class="segment" 
         *ngFor="let status of statusSteps; let i = index"
         [ngClass]="setStatusStepClass(i)" 
    >
        .
    </div>
</div>
